module.exports = __webpack_public_path__ + "img/circle-table-2.6a9e2de7.png";